import { ActionVariant } from "@faire/retailer-visitor-shared/views/SignUp/select-payment-terms/SelectNetTermsStep";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";

interface IProps {
  onSubmit: () => void;
  isLoading: boolean;
  actionVariant: ActionVariant;
}

export const SecondaryAction: React.FC<IProps> = ({
  onSubmit,
  isLoading,
  actionVariant,
}) => {
  if (
    actionVariant === "SCC_LIMIT_INCREASE_EXPERIMENT" ||
    actionVariant === "OPEN_WITH_FAIRE_ELIGIBLE"
  ) {
    return (
      <Column
        align="center"
        style={{
          width: "100%",
        }}
      >
        <Spacer height="3x" />
        <Button
          variant="tertiary"
          onClick={onSubmit}
          data-test-id="start-shopping"
        >
          <Typography>
            <StrictLocalMsg
              defaultMessage="Start shopping"
              description={{
                text: "Button to start shopping",
                img: "https://cdn.faire.com/fastly/f25842d597327c0c85793ebcd169a31fadb92c97533cb3b0f977f0b140db5283.png",
              }}
            />
          </Typography>
        </Button>
      </Column>
    );
  }

  return actionVariant === "UPMARKET_QUALIFIED" ? null : (
    <Column
      align="center"
      style={{
        width: "100%",
      }}
    >
      <Spacer height="3x" />
      <Button
        loading={isLoading}
        variant="tertiary"
        onClick={onSubmit}
        data-test-id="maybe-later"
      >
        <Typography>
          <StrictLocalMsg
            defaultMessage="Maybe later"
            description={{
              text: "Button to skip payment terms for now",
              img: "https://cdn.faire.com/fastly/ee58f6a470130806b26663ed1eaff1a92135ec4c6f5f4a425e46f4af13bd0206.png",
            }}
          />
        </Typography>
      </Button>
    </Column>
  );
};
